import { AppTextService } from '@fi-shared/app-text';
import { createMap } from '@fi-shared/utils/create-map';

export enum fiCustomerType {
    Intranet = 1,
    Other = 2,
    Reseller = 3,
}

export const fiCustomerTypes = [
    {
        Id: fiCustomerType.Intranet,
        TextId: 'customer_type_intranet',
    },
    {
        Id: fiCustomerType.Other,
        TextId: 'customer_type_other',
    },
    {
        Id: fiCustomerType.Reseller,
        TextId: 'customer_type_reseller',
    },
];

const fiCustomerTypesMap = createMap(fiCustomerTypes, 'Id');
export function fiCustomerTypeName(customerType: fiCustomerType, appText: AppTextService) {
    if (fiCustomerTypesMap.hasOwnProperty(customerType)) return appText.get(fiCustomerTypesMap[customerType].TextId);

    throw 'FI: Unknown customer type ' + customerType;
}
